export default __webpack_public_path__ + "static/media/before-footer-img1.be152358.png";